<template>
  <div class="overlay">
    <div class="overlay__inner">
      <div class="panel">
        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <div class="panel__header">
              <h3 class="panel__title">Review Payout</h3>

              <span class="overlay__close" @click="done">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Commission Due</label>
                    </div>

                    <div class="cell auto">
                      <div>{{ payoutTotalDisplay }}</div>
                    </div>
                  </div>
                </div>

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Additonal Payment</label>
                    </div>

                    <div class="cell auto">
                      <div><input class="medium-input" type="text"
                                  v-on:keyup="addPayment"></div>
                    </div>
                  </div>
                </div>

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Pay To</label>
                    </div>

                    <div class="cell auto">
                      <div>{{ vendorName }}</div>
                    </div>
                  </div>
                </div>

                <div class="form-field" v-if="vendorPayPalEmail && vendorPayPalEmail.length > 0">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Pay with PayPal <small>(beta)</small><br>
                        <div style="font-size:13px;line-height:1.1;color: #ddd; font-weight: 400;">
                          <i>{{ vendorPayPalEmail }}</i>
                        </div>
                      </label>
                    </div>

                    <div class="cell auto">
                      <div>
                        <div :class="['checkbox-choice', pay_w_paypal ? 'active' : '']" @click="clickPayPal"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Note</label>
                    </div>

                    <div class="cell auto">
                      <div>
                        <textarea id="payout-note" rows="4"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="payout__totals form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Total Payout</label>
                    </div>

                    <div class="cell auto text-right">
                      <div class="payout__total-payout focus-text">{{ payoutTotalCombinedDisplay }}</div>
                    </div>
                  </div>
                </div>
              </form>

              <div class="text-alert-color text-right" v-if="error">
                {{ errorMessage }}</div>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="done">Cancel</button>

              <button @click="submitPayout">Confirm Payout</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import checkbox from '@/globals/checkbox'

export default {
  props: [
    'vendorId',
    'vendorName',
    'vendorPayPalEmail',
    'payoutTotal',
    'payoutAll',
    'lineItemIds'
  ],
  mixins: [client, utils],
  components: {
    checkbox
  },
  data: function () {
    return {
      loading: false,
      pay_w_paypal: false,
      payoutTotalDisplay: '$0.00',
      payoutTotalCombinedDisplay: '$0.00',
      additionalPayment: 0.0,
      error: false,
      errorMessage: ''
    }
  },
  methods: {
    done () {
      this.$emit('done', false)
    },
    addPayment (e) {
      this.additionalPayment = e.target.value

      if (this.additionalPayment) {
        if (this.payoutTotal === null) {
          this.payoutTotalCombinedDisplay = this.formatMoney(this.additionalPayment)
        } else {
          this.payoutTotalCombinedDisplay = this.formatMoney(this.payoutTotal + parseFloat(this.additionalPayment))
        }
      } else {
        this.payoutTotalCombinedDisplay = 'N/A'
      }
    },
    clickPayPal () {
      this.pay_w_paypal = !this.pay_w_paypal
    },
    submitPayout () {
      this.loading = true
      this.error = false
      let note = document.getElementById('payout-note').value

      let data = {
        vendor: this.vendorId,
        pay_w_paypal: this.pay_w_paypal,
        note: note
      }

      if (this.payoutAll && this.lineItemIds.length === 0) {
        data['all_line_items'] = true
      } else {
        data['line_item_ids'] = this.lineItemIds
      }

      if (this.additionalPayment !== 0.0) {
        data['additional_pay'] = this.additionalPayment
      }

      this.request('post', '/vendors/payouts/create/', data).then(response => {
        this.request('get', '/vendors/update-commissions/' + this.vendorId + '/').then(response => {
          this.$emit('done', true)
        })
      }).catch(error => {
        this.loading = false

        if (error) {
          this.errorMessage = error[0]
          this.error = true
        }
      })
    }
  },
  created () {
    if (this.payoutTotal === null) {
      this.payoutTotalDisplay = 'N/A'
      this.payoutTotalCombinedDisplay = 'N/A'
    } else {
      this.payoutTotalDisplay = this.formatMoney(this.payoutTotal)
      this.payoutTotalCombinedDisplay = this.formatMoney(this.payoutTotal)
    }
  }
}
</script>

<style lang="scss">
@import '../styles/mixins';
@import '../styles/variables';

.payout {
  &__totals {
    padding-top: 30px;
  }

  &__total-payout {
    font-size: 24px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/globals/payout.vue